import React from "react";

import { Icon } from "components/Icon";
import styled from "styled-components";

import { SP_KEY__CONFERENCE_CALLS } from "const";
import BaseNav from "components/base/BaseNav";


import { Dropdown, FlexboxGrid, Nav } from "rsuite";

export default ({
    activeTab,
    onSelect,
    spKey,
    isMobile = false
}) => {

    const tabItems = [
        { id: "numberForm", eventKey: "numberForm", title: "Number allocation" },
        { id: "massForm", eventKey: "massForm", title: "Mass allocation" },
        ...[spKey !== SP_KEY__CONFERENCE_CALLS ?
            { id: "listForm", eventKey: "listForm", title: "List allocation" }
            : null
        ],
        ...[spKey !== SP_KEY__CONFERENCE_CALLS ?
            { id: "templateListForm", eventKey: "templateListForm", title: "Template list allocation" }
            : null
        ],
        ...[spKey !== SP_KEY__CONFERENCE_CALLS ?
            { id: "sequenceForm", eventKey: "sequenceForm", title: "Sequence allocation" }
            : null
        ]
    ].filter(item => !!item);

    const dropdownTitle = (tabItems.find(item => item.eventKey === activeTab) || {}).title;

    if (isMobile)
        return (
            <StyledHeader>
                <FlexboxGrid align={"middle"} justify={"space-between"}>
                    <FlexboxGrid.Item>
                        <Title>{dropdownTitle || "Number allocation"}</Title>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item>
                        <Dropdown
                            appearance="ghost"
                            icon={<Icon icon={"bars"} />}
                            onSelect={onSelect}
                            placement={"bottomEnd"}
                            activeKey={activeTab}
                        >
                            {tabItems.map(item => (
                                <Dropdown.Item key={item.id} eventKey={item.eventKey}>{item.title}</Dropdown.Item>
                            ))}
                        </Dropdown>
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </StyledHeader>
        );

    return (
        <StyledBaseNav
            activeKey={activeTab}
            onSelect={onSelect}
            appearance="tabs"
            style={{ marginBottom: 20 }}
        >
            {tabItems.map(item => (
                <Nav.Item key={item.id} eventKey={item.eventKey}>{item.title}</Nav.Item>
            ))}
        </StyledBaseNav>
    );
};

const StyledHeader = styled.div`
    position: relative;
    margin-bottom: 20px;
`;

export const Title = styled.div`
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    color: var(--color-main);
`;


const StyledBaseNav = styled(BaseNav)`
    && {
        @media (max-width: 767px) {
            overflow: auto;
        }
    }
`;